import React from 'react';
import { SaveOutlined, StopOutlined } from '@ant-design/icons';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Button, Flex } from 'antd';

const ModalFormFooter = ({ formId, onCancel, loading, disabled, isEditing }) => {
    const translate = useTranslate();
    return (
        <Flex justify="end" gap={8} style={{ padding: '8px 16px' }}>
            <Button danger onClick={onCancel} icon={<StopOutlined />}>
                {translate.formatMessage(commonMessage.cancel)}
            </Button>
            <Button
                type="primary"
                htmlType="submit"
                form={formId}
                loading={loading}
                disabled={disabled}
                icon={<SaveOutlined />}
            >
                {isEditing
                    ? translate.formatMessage(commonMessage.update)
                    : translate.formatMessage(commonMessage.create)}
            </Button>
        </Flex>
    );
};

export default ModalFormFooter;
